module.exports = __webpack_public_path__ + "img/head_bg2.f0e371de.png";